module.exports = __webpack_public_path__ + "static/media/Safari-120.7fa00d94.png";


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/assets/img/navegadores/Safari-120.png
// module id = 2320
// module chunks = 0